module.exports = __webpack_public_path__ + "static/media/19ESCAP49.d03bee98.jpg";